import { RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { usePWA } from "@/hooks/usePWA";

const PWAUpdatePrompt = () => {
  const { needRefresh, updateServiceWorker } = usePWA();

  if (!needRefresh) return null;

  return (
    <div className="fixed top-4 left-4 right-4 z-50 md:left-auto md:right-4 md:w-80 animate-slide-down">
      <div className="bg-card border border-border rounded-xl shadow-lg p-4 flex items-center gap-3">
        <RefreshCw className="h-5 w-5 text-primary shrink-0" />
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium">Nueva versión disponible</p>
          <p className="text-xs text-muted-foreground">Actualiza para ver las mejoras</p>
        </div>
        <Button 
          size="sm" 
          onClick={() => updateServiceWorker(true)}
          className="shrink-0"
        >
          Actualizar
        </Button>
      </div>
    </div>
  );
};

export default PWAUpdatePrompt;
